import { render, staticRenderFns } from "./wawalist.vue?vue&type=template&id=601f73ae"
import script from "./wawalist.vue?vue&type=script&lang=js"
export * from "./wawalist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports